import { Box, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";

interface SendGridIntegrationFormProps {
  editMode?: boolean;
  initialData?: {
    apiKey?: string;
  };
  onValidationChange: (isValid: boolean) => void;
  onDataChange: (data: { apiKey: string }) => void;
}

export default function SendGridIntegrationForm({
  editMode = false,
  initialData,
  onValidationChange,
  onDataChange,
}: SendGridIntegrationFormProps) {
  const [apiKey, setApiKey] = useState(initialData?.apiKey || "");

  // Validate form
  useEffect(() => {
    const isValid = apiKey.trim() !== "";
    onValidationChange(isValid);
  }, [apiKey, onValidationChange]);

  // Notify parent of data changes
  useEffect(() => {
    onDataChange({
      apiKey,
    });
  }, [apiKey, onDataChange]);

  return (
    <Box>
      <TextField
        sx={{ mt: 1 }}
        fullWidth
        type="password"
        value={apiKey}
        label="SendGrid API Key"
        helperText="Your SendGrid API key from your SendGrid account settings"
        onChange={(e) => setApiKey(e.target.value)}
        required
      />
    </Box>
  );
}
